"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Oauth1Helper = void 0;
const oauth_signature_1 = __importDefault(require("oauth-signature"));
const oauth1_utils_1 = require("../utils/oauth1-utils");
const infinity_logger_1 = require("@carrier/infinity-logger");
class Oauth1Helper {
    generateNonce(timestamp, oauth_token) {
        let randomNumber = oauth1_utils_1.generateRandomNumber(10000);
        let nonceStr = `${timestamp}${oauth_token}${randomNumber}`;
        return oauth1_utils_1.encryptString(nonceStr);
    }
    buildAuthorizationHeader(oauth1Header) {
        return "OAuth "
            + "realm=\"" + encodeURIComponent(oauth1Header.url) + "\""
            + ",oauth_consumer_key=\"" + oauth1Header.consumerKey + "\""
            + ",oauth_token=\"" + oauth1Header.token + "\""
            + ",oauth_signature_method=\"" + oauth1Header.signatureMethod + "\""
            + ",oauth_timestamp=\"" + oauth1Header.timestamp + "\""
            + ",oauth_nonce=\"" + oauth1Header.nonce + "\""
            + ",oauth_version=\"" + oauth1Header.version + "\""
            + ",oauth_signature=\"" + encodeURIComponent(oauth1Header.signature) + "\"";
    }
    generateSignature(oauthSigRequest) {
        let httpMethod = oauthSigRequest.httpMethod.toUpperCase();
        let url = oauthSigRequest.url;
        let oauthParams = {
            oauth_consumer_key: oauthSigRequest.consumerKey,
            oauth_token: oauthSigRequest.token,
            oauth_signature_method: oauthSigRequest.signatureMethod,
            oauth_timestamp: oauthSigRequest.timestamp,
            oauth_nonce: oauthSigRequest.nonce,
            oauth_version: oauthSigRequest.version,
        };
        let params = Object.assign(Object.assign({}, oauthParams), oauthSigRequest.parameters);
        // Parameters in the OAuth HTTP Authorization header excluding the realm parameter
        delete params["realm"];
        // The oauth_signature parameter MUST be excluded.
        delete params["oauth_signature"];
        // node js version
        //     let key = consumerSecret + "&" + tokenSecret;
        //     let base64 = crypto.createHmac("sha1", key)
        //         .update(baseString)
        //         .digest("base64");
        let signature = oauth_signature_1.default.generate(httpMethod, url, params, oauthSigRequest.consumerSecret, oauthSigRequest.tokenSecret, { encodeSignature: false });
        logger.debug("generateSignature", `signature ${signature}`);
        return signature;
    }
}
exports.Oauth1Helper = Oauth1Helper;
const logger = infinity_logger_1.createLogger(Oauth1Helper.name);
//# sourceMappingURL=oauth1.helper.js.map